'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const EventTimelinePremiumVirtualizerContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") EventTimelinePremiumVirtualizerContext.displayName = "EventTimelinePremiumVirtualizerContext";
export function useEventTimelinePremiumVirtualizerStore() {
  const store = React.useContext(EventTimelinePremiumVirtualizerContext);
  if (!store) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: EventTimelinePremiumVirtualizerContext is missing. ' + 'Make sure the calling component is rendered inside <EventTimelinePremiumContent />.' : _formatErrorMessage(281));
  }
  return store;
}